import { useEffect, useState } from "react";

const SEGMENTS_KEY = "segments";

// Helper functions to manage centralized segment storage
function getSegments(): Record<string, string> {
  if (typeof window === "undefined") return {};
  const saved = localStorage.getItem(SEGMENTS_KEY);
  return saved ? JSON.parse(saved) : {};
}

function saveSegments(segments: Record<string, string>) {
  localStorage.setItem(SEGMENTS_KEY, JSON.stringify(segments));
}

function removeSegment(key: string) {
  const segments = getSegments();
  delete segments[key];
  saveSegments(segments);
}

export function useSegment<T extends string>(
  key: string,
  initial: T,
  shouldRemove = true
) {
  const [segment, setSegment] = useState<T>(() => {
    if (typeof window === "undefined") return initial;
    const segments = getSegments();
    return (segments[key] as T) || initial;
  });

  useEffect(() => {
    // Save to centralized segments object
    const segments = getSegments();
    segments[key] = segment;
    saveSegments(segments);

    return () => {
      if (shouldRemove) {
        removeSegment(key);
      }
    };
  }, [key, segment, shouldRemove]);

  return { segment, setSegment };
}